import axios from "axios"
import moment from "moment"

import { getUserInfo } from "acciondigital-commons/usuarios-commons"

import { frdbe, gtage } from "acciondigital-basic-theme/src/utils/gatgUtils"

import { enviarCliq } from "./siteUtils"

const zfe = (payload) => axios.post("/zflow-884903601?zapikey=1001.1757c8dd3109e9fe81d498c28519d136.5630709d7e8baef3e258b6f0e5321d3b&isdebug=false", payload)
const zfe_CrearPago = (payload) => axios.post("/zflow-884903601?zapikey=1001.af13e0228bc14d0dcd76e3489e8451ca.269f102821eb8d9c406b32d09dce86a7&isdebug=false", payload)
const zfe_Registro = (payload) => axios.post("/zflow-884903601?zapikey=1001.670eedd5d8c8d7a530f40270c185fc57.9c93fd1d432264749aa34b15ede0ce73&isdebug=false", payload)
const zfe_ActivarSuscripcion = (payload) => axios.post("/zflow-884903601?zapikey=1001.4bbfe63d48871367f1595e824bc38d07.ba5863eeeb1d08daa3665f816f09dadf&isdebug=false", payload)

export const siteEvt_Registro = (siteId, user, data) => {
  console.debug(
    "🚀 ~ siteEventsUtils.js:6 ~ constsiteEvt_Registro= ~ user:",
    user,
  )
  gtage("sign_up", user?.providerData?.[0].providerId, {
    method: user.providerData[0].providerId,
  })

  const {info, ...restData} = data || {}

  frdbe(siteId, {
    evento: "userRegistro",
    user: getUserInfo(user),
    ...restData,
    ...info,
  })

// email
// evento
// nombre
// telefono

  zfe_Registro({
    evento: "userRegistro",
    email: info?.email || user?.email,
    nombre: info?.nombre || user?.displayName,
    telefono: info?.telefono || user?.phoneNumber,
    provider: user?.providerData?.[0]?.providerId || null,
    origen: info?.origen || null,
    patrocionador: info?.patrocinador || null,
  }).catch((err) => console.error(err))
}

export const siteEvt_Login = (siteId, user) => {
  gtage("login", user?.providerData?.[0].providerId, {
    method: user?.providerData?.[0].providerId,
  })
  frdbe(siteId, {
    evento: "userLogin",
    user: getUserInfo(user),
  })
}

export const siteEvt_Logout = (siteId, { email, uid }) => {
  gtage("logout")
  frdbe(siteId, {
    evento: "userLogout",
    user: uid ? { uid, email } : null,
  })
}

export const siteEvt_IniciaSesion = (siteId, user, userProperties) => {
  const {
    membresiasLst,
    nego,
    suscripcionesLst,
    tienda,
    //
    user: user_,
    uid,
    membresiaVigente_COMPRADOR_MAYORISTA,
    membresias,
    menuItemCatalogo,
    menuItemCotizador,
    menuItemPuntoVenta,
    negos,
    negosLst,
    tiendas,
    tiendasLst,
    suscripciones,
    //
    ...restRaw
  } = userProperties || {}
  // Convert undefined values to null in rest
  const rest = Object.fromEntries(
    Object.entries(restRaw).map(([k, v]) => [k, v === undefined ? null : v]),
  )
  // console.debug("🚀 ~ siteEventsUtils.js:11 ~ constsiteEvt_IniciaSesion= ~ rest:", rest)

  /*
  esAdmin	true
  susVencida
  tieneNego
  tieneSuscripcion
  tieneSuscripcionVigente
  tieneTienda
  suscripcionInfo
  negocioInfo
  membresiaInfo
  */

  const userProps = {
    ...rest,
    nego_slug: nego?.slug || null,
    nego_nombre: nego?.nombre || null,
    esAdmin: rest?.esAdmin ? "SI" : "NO",
    esAnonimo: rest?.esAnonimo ? "SI" : "NO",
    susVencida: rest?.susVencida ? "SI" : "NO",
    susPorVencer: rest?.susPorVencer ? "SI" : "NO",
    tieneSuscripcion: rest?.tieneSuscripcion ? "SI" : "NO",
    tieneSuscripcionVigente: rest?.tieneSuscripcionVigente ? "SI" : "NO",
    tieneNego: rest?.tieneNego ? "SI" : "NO",
    tieneTienda: rest?.tieneTienda ? "SI" : "NO",

  }

  if (suscripcionesLst?.[0]) userProps.suscripcion = suscripcionesLst[0]
  if (membresiasLst?.[0]) userProps.membresia = membresiasLst[0]
  if (nego) userProps.negocio = nego
  if (tienda) userProps.tienda = tienda

  frdbe(siteId, {
    evento: "userSesion",
    user: getUserInfo(user),
    ...userProps,
  })

  // zfe({evento: "userSesion",...getUserInfo(user)})
}

export const siteEvt_CrearPago = (siteId, pagoInfo, props) => {
  const { origenInfo } = props || {}
  const { ["user-info"]: user, ...pago } = pagoInfo
  const fechaDate = new Date(pagoInfo.fechaPagoInt)
  // console.debug("🚀 ~ siteEventsUtils.js:135 ~ constsiteEvt_CrearPago= ~ pagoInfo:", {pagoInfo, fechaDate, origenInfo})

  frdbe(
    siteId,
    {
      evento: "pagoCrear",
      user: user ? user : { email: pagoInfo.email },
      ...pago,
    origenInfo: origenInfo ? {origen: pago.origen, ...origenInfo} : null
    },
    { fechaDate },
  )

/*
sus_ACTIVO : null,
 tipo : "RENOVACION",
  user__email : "user5@cabbur.me",
 meses : 3,
nombre : "Catálogo Truper 2026 con 3 meses de actualizaciones", (Producto AF)
fechaActualizacionStr : "jueves, 3 de julio de 2026 23:26",  (dd/mm/aaaa)
inicio_aniomes : "202601",
 fechaCreacionStr : "miércoles, 2 de julio de 2026 19:20",  (dd/mm/aaaa)
 fin_aniomes : 202609,
fechaPago : "2026-07-03T17:25:58-06:00",  (dd/mm/aaaa)
   producto : "Catálogo Truper 2026 Excel", (Formulario Pago)
origen : "mercadopago",

 evento : "pagoCrear",
 telefono : "8112901464",
 nombre : "user", DEL CHECK OUT
apellidos : "5",
patrocinador : null, //del user
origen : null, // del user
 telefono : null, DEL CHECK OUT
*/

    zfe_CrearPago({
    evento: "pagoCrear",
    sus_ACTIVO: pagoInfo.sus_ACTIVO || null,
    tipo: pagoInfo.tipo || "RENOVACION",
    user_email: pagoInfo.user_email || pagoInfo.email,
    sus_meses: pagoInfo.suscripcion?.meses ? (""+pagoInfo.suscripcion.meses) : null,
    sus_nombre: pagoInfo.suscripcion?.nombre || null,
    // 23/12/2024
    sus_fechaActualizacion: pagoInfo.suscripcion?moment(pagoInfo.suscripcion?.fechaActualizacionInt).format("DD/MM/YYYY"):null,
    sus_fechaCreacion: pagoInfo.suscripcion?moment(pagoInfo.suscripcion?.fechaCreacionInt).format("DD/MM/YYYY"):null,
    sus_inicio_aniomes: pagoInfo.suscripcion?.inicio_aniomes ? (""+pagoInfo.suscripcion.inicio_aniomes) : null,
    sus_fin_aniomes: pagoInfo.suscripcion?.fin_aniomes ? (""+pagoInfo.suscripcion.fin_aniomes) : null,
    fechaPago: moment(pagoInfo.fechaPagoInt).format("DD/MM/YYYY"),
    producto: pagoInfo.producto || null,
    user_origen: pagoInfo.user?.origen || null,
    user_patrocinador: pagoInfo.user?.patrocinador || null,
    telefono: pagoInfo.telefono || null,
    nombre: pagoInfo.nombre,
    apellidos: pagoInfo.apellidos,
    origen: pagoInfo.origen || null,
  }).catch((err) => console.error(err))
}

  // const { ["user-info"]: user, ...pago } = pagoInfo

  // // pagoInfo.fechaPagoInt
  // const fechaDate = new Date(pagoInfo.fechaPagoInt)

  // return frdbe(
  //   siteId,
  //   {
  //     evento: "pagoCrear",
  //     user: user ? user : { email: pagoInfo.email },
  //     ...pago,
  //   },
  //   { fechaDate }
  // )

export const siteEvt_CrearSuscripcion = (siteId, user, susInfo, props) => {
  frdbe(siteId, {
    evento: "suscripcionCrear",
    user: user ? getUserInfo(user) : {email: susInfo.email}, 
    ...susInfo,
  })
}

export const siteEvt_ActualizarSuscripcion = ( siteId, user, susInfo, props) => {
  frdbe(siteId, {
    evento: "suscripcionActualizar",
    user: user ? getUserInfo(user) : {email: susInfo.email}, 
    ...susInfo,
  })
}

export const siteEvt_CambiarSuscripcion = ( siteId, user, susInfo, props) => {
  frdbe(siteId, {
    evento: "suscripcionCambiar",
    user: user ? getUserInfo(user) : {email: susInfo.email}, 
    ...susInfo,
  })
}

export const siteEvt_EliminarSuscripcion = (siteId, user, susInfo, props) => {
  frdbe(siteId, {
    evento: "suscripcionEliminar",
    user: user ? getUserInfo(user) : {email: susInfo.email},
    ...susInfo,
  })
}

export const siteEvt_ActivarSuscripcion = (siteId, user, susInfo, props) => {

  const {infoUsuarios} = props || {}

  const userInfo = getUserInfo(user, infoUsuarios)
  frdbe(siteId, {
    evento: "suscripcionActivar",
    user: userInfo,
    ...susInfo,
  })
  zfe_ActivarSuscripcion({
    evento: "suscripcionActivar",
  user_createdAt: userInfo.createdAt,
  user_createdAtInt: userInfo.createdAtInt,
  user_email: userInfo.email,
  user_lastLoginAt: userInfo.lastLoginAt,
  user_lastLoginAtInt: userInfo.lastLoginAtInt,
  user_nombre: userInfo.nombre,
  user_provider: userInfo.provider,
  user_uid: userInfo.uid,
  user_origen: userInfo.origen,
  user_patrocinador: userInfo.patrocinador,
  ...susInfo
  }).catch((err) => console.error(err))
}

export const siteEvt_Search = (siteId, user, search_term, props) => {
  gtage("search", search_term, { search_term })
  frdbe(siteId, {
    evento: "search",
    search_term,
    user: getUserInfo(user),
  })
}

export const siteEvt_ViewItem_Truper = (siteId, user, item, props) => {
  const item_name = `${item.codigo}|${item.descripcion}`
  const itemInfo = {
    item_id: item.id,
    item_name,
    brand: item.Marca || item.marca,
    codigo: item.codigo,
  }
  const buscador = props?.buscador || "truper"
  siteEvt_ViewItem(siteId, user, item_name, itemInfo, { ...props, buscador })
}

export const siteEvt_ViewItem_Ferre = (siteId, user, item, props) => {
  const item_name = `${item.nombre}`
  const itemInfo = {
    item_id: item.uuid,
    item_name,
    brand: item.marca,
    codigo: item.id,
  }
  const buscador = props?.buscador || "ferreteria"

  siteEvt_ViewItem(siteId, user, item_name, itemInfo, { ...props, buscador })
}

export const siteEvt_ViewItem = (
  siteId,
  user,
  item_name,
  itemInfo,
  props = {},
) => {
  const { buscador } = props

  // const item_name = `${item.codigo}|${item.descripcion}`
  // const itemInfo = {
  //   item_id: item.id,
  //   item_name,
  //   brand: item.Marca || item.marca,
  //   codigo: item.codigo,
  // }
  gtage("view_item", true, {
    currency: "MXN",
    value: 0,
    items: [itemInfo],
    item_name,
    codigo: itemInfo.codigo,
  })

  frdbe(siteId, {
    evento: "view_item",
    ...itemInfo,
    buscador: buscador || null,
    user: getUserInfo(user),
  })
}

export const siteEvt_CotizacionNueva = (
  siteId,
  user,
  cotizacionInfo,
  duplicado,
) => {
  const cotInfo = {
    cotizacionId: cotizacionInfo.uuid,
    duplicado: duplicado || false,
  }
  frdbe(siteId, {
    evento: "cotizacionNueva",
    ...cotInfo,
    user: getUserInfo(user),
  })
}

export const siteEvt_PopupAnuncio = (
  siteId,
  apiUrl,
  modoPruebas,
  user,
  popupInfo,
  promoInfo,
) => {
  enviarCliqPopup(apiUrl, modoPruebas, "clickPopup", user, popupInfo, promoInfo)
  // console.debug("🚀 ~ siteEventsUtils.js:69 ~ promoInfo:", promoInfo)
  frdbe(siteId, {
    evento: "popupAnuncio",
    popupInfo,
    ...(promoInfo ? { promoInfo } : {}),
    user: getUserInfo(user),
  })
}

export const siteEvt_PopupCerrar = (
  siteId,
  apiUrl,
  modoPruebas,
  user,
  popupInfo,
  promoInfo,
) => {
  enviarCliqPopup(
    apiUrl,
    modoPruebas,
    "cerrarPopup",
    user,
    popupInfo,
    promoInfo,
  )
  frdbe(siteId, {
    evento: "popupCerrar",
    popupInfo,
    ...(promoInfo ? { promoInfo } : {}),
    user: getUserInfo(user),
  })
}

export const siteEvt_BannerClick = (
  siteId,
  apiUrl,
  modoPruebas,
  user,
  bannerInfo,
  promoInfo,
) => {
  enviarCliqBanner(apiUrl, modoPruebas, user, bannerInfo, promoInfo)
  console.debug("🚀 ~ siteEventsUtils.js:104 ~ promoInfo:", promoInfo)
  frdbe(siteId, {
    evento: "bannerAnuncio",
    bannerInfo,
    ...(promoInfo ? { promoInfo } : {}),
    user: getUserInfo(user),
  })
}

export const siteEvt_BotonAnuncio = (siteId, user, anuncioInfo) => {
  frdbe(siteId, {
    evento: "botonAnuncio",
    ...anuncioInfo,
    user: getUserInfo(user),
  })
}

const enviarCliqPopup = (
  apiUrl,
  modoPruebas,
  evento = "clickPopup",
  user,
  popupInfo,
  promoInfo,
) => {
  const {
    encabezado,
    descripcion,
    texto,
    path,
    imagen,
    link,
    textoBoton,
    linkInterno,
    linkInternoUsuario,
    linkInternoUsuarioNego,
    linkInternoCliente,
    linkInternoClienteNego,
  } = popupInfo
  enviarCliq(
    apiUrl,
    JSON.stringify(
      {
        [evento]: {
          modo: modoPruebas ? "PRUEBAS" : "PRODUCCION",
          encabezado,
          descripcion,
          texto,
          path,
          imagen,
          link,
          textoBoton,
          linkInterno,
          linkInternoUsuario,
          linkInternoUsuarioNego,
          linkInternoCliente,
          linkInternoClienteNego,
          user: user?.uid,
          email: user?.email,
          promoInfo,
        },
      },
      null,
      2,
    ),
  ).then(data => console.log(data))
}

const enviarCliqBanner = (apiUrl, modoPruebas, user, bannerInfo, promoInfo) => {
  const {
    titulo,
    imagen,
    link,
    textoBoton,
    textoFooter,
    linkInterno,
    linkInternoUsuario,
    linkInternoUsuarioNego,
    linkInternoCliente,
    linkInternoClienteNego,
  } = bannerInfo
  enviarCliq(
    apiUrl,
    JSON.stringify(
      {
        clickBanner: {
          modo: modoPruebas ? "PRUEBAS" : "PRODUCCION",
          titulo,
          imagen,
          link,
          textoBoton,
          textoFooter,
          linkInterno,
          linkInternoUsuario,
          linkInternoUsuarioNego,
          linkInternoCliente,
          linkInternoClienteNego,
          user: user?.uid,
          email: user?.email,
          promoInfo,
        },
      },
      null,
      2,
    ),
  ).then(data => console.log(data))
}

// Parámetros de GA4 de una pieza de anuncio; `promotion_*` e `items` solo si la pieza los tiene.
const paramsPromocion = promoInfo => ({
  creative_name: promoInfo.elemento,
  creative_slot: promoInfo.ubicacion,
  ...(promoInfo.promo?.id
    ? { promotion_id: promoInfo.promo.id, promotion_name: promoInfo.promo.descripcion }
    : {}),
  ...(promoInfo.prod?.id
    ? { items: [{ item_id: promoInfo.prod.id, item_name: `${promoInfo.prod.descripcion}` }] }
    : {}),
})

// Clic en una pieza; se identifica igual que su impresión (`siteEvt_ViewPromotion`).
export const siteEvt_SelectPromotion = (siteId, promoInfo, props) => {
  if (promoInfo?.elemento || promoInfo?.promo?.id) {
    gtage("select_promotion", true, paramsPromocion(promoInfo))

    // frdbe(siteId, {
    //   evento: "select_promotion",
    //   ...promoInfo,
    // })
  }
}

// E05: impresión de una pieza. Solo va a GA; no se guarda en Firebase.
export const siteEvt_ViewPromotion = promoInfo => {
  if (promoInfo?.elemento || promoInfo?.promo?.id)
    gtage("view_promotion", true, paramsPromocion(promoInfo))
}

// const siteEvt_BotonAnuncio_DE_LA_PAGINA_INICIO =
